/** @file Thai catalog part of area E7 (W3-03), partial; replaced whole by that area. */

/** The `restore`, `trashedOn`, `purge` and `confirmPurge` keys (spread into `projects`); partial, English fills the gaps. S0 composes it into `th`. */
export const projectsExtraTh = { restore: 'กู้คืน', trashedOn: 'ทิ้งเมื่อ {date}', purge: 'ลบถาวร', confirmPurge: 'คลิกอีกครั้งเพื่อลบ {name} ถาวร' } as const;
